import { useEffect } from "react";
import { useLocation } from "lib/router";

export default function ScrollToTop() {

  const routePath = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0 })
  }, [routePath]);

  return null;
}